import { Link } from 'react-router-dom';
import '../styles/footer.css';

const orgLinks = [
  { to: '/about',                    label: 'Overview' },
  { to: '/about',                    label: 'Software testing' },
  { to: '/about/software-development', label: 'Software Developments' },
  { to: '/services',                 label: 'Matrix Processing House' },
  { to: '/about',                    label: 'About-Us' },
  { to: '/career',                   label: 'Career@matrixpbs' },
  { to: '/contact',                  label: 'Contact Us' },
];

const workLinks = [
  'Credit Rating',
  'Business Prospects Validation',
  'Employee Credentials Check',
  'Royalty / Retention Services',
  'Banking Information Services',
];

export default function Footer() {
  return (
    <footer className="main-footer">
      {/* TOP */}
      <div className="top-footer">
        <div className="container">
          <div className="tp-ft-lft">
            <div className="ft-logo">
              <Link to="/"><span className="ft-logo-text">Matrix Processing House</span></Link>
            </div>
            <p>We have the vertical industry knowledge and process expertise to deliver strategic value to our clients, in addition to significant time and cost savings.</p>
            <p>We believe in collaborative, long-term client relationships that evolve and grow stronger over time. Our clients have grown with us since inception and are scaling up their operations every year.</p>
            <p>Matrix Processing House leverages its strong IT infrastructure to provide totally automated and customised business solutions which blends very effectively with client's existing work processes</p>
          </div>
          <div className="tp-ft-mdl">
            <div className="m-box">
              <h3>Organization</h3>
              <ul>
                {orgLinks.map((l, i) => (
                  <li key={i}><Link to={l.to}>{l.label}</Link></li>
                ))}
              </ul>
            </div>
            <div className="m-box">
              <h3>Work</h3>
              <ul>
                {workLinks.map((w, i) => (
                  <li key={i}><a href="#0">{i+1} {w}</a></li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* BOTTOM */}
      <div className="bottom-footer">
        <div className="container">
          <div className="bottm-ft-top">
            <h3>Corporate Office</h3>
          </div>
          <div className="phn">
            <div className="cnt">
              <i className="fa fa-phone" />
              <span>+91-11-45024329</span>
              <span>+91-11-45024329</span>
            </div>
            <div className="eml">
              <i className="fa fa-envelope" />
              <a href="mailto:info@matrixbps.com">info@matrixbps.com</a>
            </div>
            <div className="work-wth-us">
              <Link to="/career"><span>Work with us</span></Link>
            </div>
          </div>
          <div className="footer-address">
            Address: 8/42, Kirti Nagar Industrial Area, Kirti Nagar, New Delhi, Delhi 110015.
          </div>
          <div className="copyright">
            Copyright &copy; 2014 Matrix Processing House . All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
}
